import styled from 'styled-components'
import {IPropsCss} from './IProps'

export const PageTitle = styled.h1<IPropsCss>`
    font-family: Myriad Pro, sans-serif;
    font-size: 3rem;
    font-weight: 500;
    margin: .5rem 0;
    text-align: ${({textAlign}) => textAlign ? textAlign : 'inherit'};
    color: ${({color}) => color ? color : 'inherit'};
`

export const SectionTitle = styled.h2<IPropsCss>`
    font-family: Myriad Pro, sans-serif;
    font-size: 2.5rem;
    font-weight: 400;
    margin: .5rem 0;
    padding-left: 20px;
    text-align: ${({textAlign}) => textAlign ? textAlign : 'inherit'};
    color: ${({color}) => color ? color : 'inherit'};
`

export const SubSectionTitle = styled.h3<IPropsCss>`
    font-family: Myriad Pro, sans-serif;
    font-size: 2rem;
    font-weight: 300;
    margin: .5rem 0;
    padding-left: 40px;
    text-align: ${({textAlign}) => textAlign ? textAlign : 'inherit'};
    color: ${({color}) => color ? color : 'inherit'};
`

export const SubSectionSectionTitle = styled.h4<IPropsCss>`
    font-family: Myriad Pro, sans-serif;
    font-size: 1.3rem;
    font-weight: 200;
    font-style: italic;
    margin: .5rem 0;
    padding-left: 60px;
    text-align: ${({textAlign}) => textAlign ? textAlign : 'inherit'};
    color: ${({color}) => color ? color : 'inherit'};
`
